/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products
 *| (C) Copyright IBM Corp. 2016, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler',
	'../../../app/nls/StringResources'
], function(BaseClass, stringResources) {

	const ActionHandler = BaseClass.extend({

		getExtraCustomSpec: function({ glassContext, target }){

			const itemSpec = target && target.plugin && target.plugin.itemSpec;
			const module = (itemSpec && itemSpec.content && itemSpec.content.module) || 'dashboard-core/js/pinning/PinView';

			const dashboardView = glassContext.appController.getCurrentContentView();
			return {
				id: 'dashboardPanel',
				reuseSlideout: true,
				width: this.commonOptions.defaultWidth,
				position: 'left',
				resizable: {
					min: 300
				},
				pinning: {
					isPinned: true,
					float: false,
					display: false
				},
				label: stringResources.get('pinsOld'),
				content: {
					module,
					glassContext,
					services: dashboardView.services,
					canvasController: dashboardView.boardLoader.canvasController
				}
			};
		}

	});

	return ActionHandler;
});
